import React from "react";

const ChatBubble = ({ showBubble, message, onClick }) => {
  if (!showBubble) return null;

  return (
    <div
      className="chat-bubble"
      onClick={onClick}
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        maxWidth: "250px",
        padding: "10px 15px",
        borderRadius: "15px",
        backgroundColor: "#00aeef",
        color: "white",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        fontSize: "1rem",
        cursor: "pointer",
        zIndex: 1000,
      }}
    >
      <p style={{ margin: 0 }}>{message}</p>
    </div>
  );
};

export default ChatBubble;
